import {
  Anrede,
  Domaenenwert,
  PersonensucheParty,
  PersonensuchePersonenart,
} from '@ps20/bff-models';
import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import {
  PersonenSucheStatus,
  PersonenSucheStatusCell,
} from './personenSuche.model';
import { convertSafeDomaenenwert } from './person';

const STATUS_CELL_DATA_FOR_DISABLED_DATA: PersonenSucheStatusCell = {
  type: 'ICON',
  icon: 'exclamation-circle',
  cssClass: 'status-color-unvollstaendig',
  suchStatus: PersonenSucheStatus.UNVOLLSTAENDIG,
};

const STATUS_CELL_DATA_FOR_VALID_DATA: PersonenSucheStatusCell = {
  type: 'ICON',
  icon: '',
  suchStatus: PersonenSucheStatus.OK,
};

export interface SearchlistItem {
  id: string;
  icon: string;
  disabled?: boolean;
}

export interface PersonenSearchListItem extends SearchlistItem {
  name: string;
  geburtsdatum: string;
  ort: string;
  strasse: string;
  plz: string;
  status: PersonenSucheStatusCell;
  personData: {
    kundenverwaltungID: string;
    vorname: string;
    nachname: string;
    firmenname: string;
    businessForm: Domaenenwert;
    juristisch: boolean;
    anrede: Anrede;
    akadgrad: Domaenenwert;
    adelstitel: Domaenenwert;
    adelsbez: Domaenenwert;
    namenszusatz?: Domaenenwert;
    famstand?: Domaenenwert;
    geburtsdatum: string;
    staatsbschaft: Domaenenwert;
    heimatort: string;
    geburtsland?: Domaenenwert;
    kundennummer: string;
    adresse: {
      strasse: string;
      hausnummer: string;
      plz: string;
      ort: string;
      land?: Domaenenwert;
    };
  };
}

const PERSON_ICON = 'product-person';
const JURISTISCHE_PERSON_ICON = 'product-building';

export const mapAmisCrmResponseToPersonenSearchList = (
  person: PersonensucheParty,
): PersonenSearchListItem => {
  let myName = `${person.vorname} ${person.nachname}`;
  if (person.juristisch) {
    myName = `${person.firmenname}`;
  }
  return {
    id: person.kundenverwaltungID,
    icon:
      person.personenart === PersonensuchePersonenart.NATUERLICHE_PERSON
        ? PERSON_ICON
        : JURISTISCHE_PERSON_ICON,
    disabled: person.datenVollstaendig === false,
    name: myName,
    geburtsdatum: getGeburtsdatum(person),
    ort: person.adresse?.ort,
    plz: person.adresse?.plz,
    strasse: `${valueOrDefault(person.adresse?.strasse, '')} ${valueOrDefault(
      person.adresse?.hausnummer,
      '',
    )}`,
    personData: {
      kundenverwaltungID: valueOrDefault(person.kundenverwaltungID, ''),
      vorname: valueOrDefault(person.vorname, ''),
      nachname: valueOrDefault(person.nachname, ''),
      firmenname: valueOrDefault(person.firmenname, ''),
      juristisch: person.juristisch,
      businessForm: convertSafeDomaenenwert(person.businessForm),
      anrede: person.anrede,
      akadgrad: convertSafeDomaenenwert(person.akadgrad),
      adelstitel: convertSafeDomaenenwert(person.adelstitel),
      adelsbez: convertSafeDomaenenwert(person.adelsbez),
      adresse: {
        strasse: valueOrDefault(person.adresse?.strasse, ''),
        hausnummer: valueOrDefault(person.adresse?.hausnummer, ''),
        plz: valueOrDefault(person.adresse?.plz, ''),
        ort: valueOrDefault(person.adresse?.ort, ''),
        land: convertSafeDomaenenwert(person.adresse?.land),
      },
      famstand: convertSafeDomaenenwert(person.famstand),
      geburtsdatum: getGeburtsdatum(person) || null,
      geburtsland: convertSafeDomaenenwert(person.geburtsland),
      heimatort: person.heimatort,
      kundennummer: person.kundennummer,
      staatsbschaft: convertSafeDomaenenwert(person.staatsbschaft),
      namenszusatz: convertSafeDomaenenwert(person.namenszusatz),
    },
    status: getStatusCellForData(person),
  };
};

function getGeburtsdatum(person: PersonensucheParty): string {
  return (person.geburtsdatum && dayjs(person.geburtsdatum).format(DATEFORMAT_LOCAL_STATE)) || '';
}

function valueOrDefault(value: unknown, defaultValue: string): string {
  return (value as string) || defaultValue;
}

function getStatusCellForData(person: PersonensucheParty): PersonenSucheStatusCell {
  return person.datenVollstaendig === false
    ? STATUS_CELL_DATA_FOR_DISABLED_DATA
    : STATUS_CELL_DATA_FOR_VALID_DATA;
}

export const markAsDisabled = (item: PersonenSearchListItem): void => {
  item.status = STATUS_CELL_DATA_FOR_DISABLED_DATA;
  item.disabled = true;
};
